import Link from 'next/link';

interface Props {
  children: React.ReactNode;
  href: string;
  prefetch?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export default function MonsterStyledLinkNext({ children, href, prefetch = true, target }: Props) {
  return (
    <Link
      prefetch={prefetch}
      href={href}
      className='text-monsterGreen hover:text-monsterPurple gradient_underline'
      target={target}
    >
      {children}
    </Link>
  );
}
